import FadingContainer, { FadingContainerProps } from './FadingContainer';

export default FadingContainer;
export type { FadingContainerProps };
